import Swiper, { Autoplay, Mousewheel } from 'swiper'

Swiper.use([Autoplay, Mousewheel])

export function draggableSlider(element: HTMLElement) {
  const slider = element.querySelector('.swiper') as HTMLElement

  // console.log(slider)
  const loop = element.dataset.loop ? element.dataset.loop : null
  const mousewheel = element.dataset.mousewheel ? true : null
  const autoplay = element.dataset.autoplay !== 'false' ? { delay: 2500, disableOnInteraction: true, pauseOnMouseEnter: true } : false
  const slidesPerView = element.dataset.slides ? element.dataset.slides : 3

  const swiper = new Swiper(slider, {
    // Optional parameters
    // direction: 'horizontal',
    // loop: true,
    // If we need pagination
    speed: 1500,
    loop: loop,
    mousewheel: mousewheel ? mousewheel : false,
    autoplay: { delay: 2500, disableOnInteraction: true, pauseOnMouseEnter: true },
    breakpoints: {
      0: {
        slidesPerView: 1.05,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 1.75
      },
      992: {
        slidesPerView: 2.5
      },
      1200: {
        slidesPerView: slidesPerView == 'auto' ? 'auto' : 3,
        spaceBetween: 40
      },
      1920: {
        slidesPerView: slidesPerView == 'auto' ? 'auto' : 4,
        spaceBetween: 40
      }
    },
    on: {
      afterInit: function (swip) {
        // if(autoplay) {

          swip.autoplay.stop()

          slider.addEventListener("mouseenter", (event) => { swip.autoplay.stop() });
          slider.addEventListener("mouseleave", (event) => { swip.autoplay.start() });
        // }
      }
    }
  })

  // Start autoplay when slider is in viewport
  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        swiper.autoplay.start()
        // You can remove the observer if needed
        observer.unobserve(entry.target);
      }
    });
  }

  // Options for the Intersection Observer
  const options = {
    root: null, // Use the viewport as the root
    rootMargin: '0px', // No margin
    threshold: 0.5, // Trigger when 50% of the element is visible
  };

  // Create the Intersection Observer
  const observer = new IntersectionObserver(handleIntersection, options);
  observer.observe(slider);


}
